import { Buffer } from 'buffer';

import { createRoot } from 'react-dom/client';

import './index.css';
import './instrument'; // Sentry initialization
import App from './App';
import reportWebVitals from './reportWebVitals';

window.Buffer = Buffer;

const container = document.getElementById('root');
if (!container) {
  throw Error('app id not found');
}
const root = createRoot(container);

root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
